(function () {
  'use strict';

  var STORAGE_KEY = 'ns_wishlist';
  var SYNC_EVENT = 'ns:wishlist:update';
  var styleId = 'ns-wishlist-sync-style';
  var observerStarted = false;
  var syncTimer = null;
  var stickyDockFrame = null;
  var stickyDockObserver = null;
  var stickyDockResizeObserver = null;
  var observedStickyAtc = null;
  var observedFloatingWidget = null;

  function normaliseList(value) {
    if (!Array.isArray(value)) return [];
    return value
      .map(function (item) { return String(item || '').trim(); })
      .filter(Boolean)
      .filter(function (item, index, list) { return list.indexOf(item) === index; });
  }

  function getWishlist() {
    try {
      return normaliseList(JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'));
    } catch (e) {
      return [];
    }
  }

  function setWishlist(list) {
    var normalised = normaliseList(list);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(normalised));
    } catch (e) {}
    window.dispatchEvent(new CustomEvent(SYNC_EVENT, {
      detail: {
        ids: normalised.slice(),
        count: normalised.length
      }
    }));
    return normalised;
  }

  function injectStyle() {
    if (document.getElementById(styleId)) return;

    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = [
      'wishlist-link-floating.ns-wishlist-floating-synced::after {',
      '  content: attr(data-ns-count);',
      '  position: absolute;',
      '  right: -2px;',
      '  bottom: -4px;',
      '  z-index: 2147483647;',
      '  min-width: 18px;',
      '  height: 18px;',
      '  padding: 0 5px;',
      '  border-radius: 999px;',
      '  display: inline-flex;',
      '  align-items: center;',
      '  justify-content: center;',
      '  box-sizing: border-box;',
      '  background: #6D2077;',
      '  border: 2px solid #fff;',
      '  color: #fff;',
      '  font: 800 11px/1 Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;',
      '  box-shadow: 0 4px 14px rgba(109, 32, 119, 0.32);',
      '  pointer-events: none;',
      '}',
      'wishlist-link-floating.ns-wishlist-floating-synced {',
      '  color: #fff !important;',
      '}',
      'wishlist-link-floating.ns-wishlist-floating-synced svg,',
      'wishlist-link-floating.ns-wishlist-floating-synced path,',
      'wishlist-link-floating.ns-wishlist-floating-synced [class*="icon"] {',
      '  color: #fff !important;',
      '  stroke: #fff !important;',
      '}',
      'wishlist-link-floating.ns-wishlist-floating-synced svg [fill]:not([fill="none"]) {',
      '  fill: #fff !important;',
      '}',
      'wishlist-link-floating.ns-wishlist-floating-synced [class*="counter"],',
      'wishlist-link-floating.ns-wishlist-floating-synced [class*="count"],',
      'wishlist-link-floating.ns-wishlist-floating-synced [class*="badge"] {',
      '  opacity: 0;',
      '}',
      '@media (max-width: 767.98px) {',
      '  body.template-product wishlist-link-floating.ns-wishlist-floating-synced.ns-wishlist-floating--sticky-docked {',
      '    --button-offset-top: var(--ns-wishlist-dock-top);',
      '    --button-offset-bottom: auto;',
      '    --button-offset-left: auto;',
      '    --button-offset-right: 0.86rem;',
      '    --button-size: 44px;',
      '    --icon-size: 20px;',
      '    --counter-size: 15px;',
      '    z-index: 12040;',
      '  }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function patchCounterText(root, count) {
    if (!root || !root.querySelectorAll) return;
    var selectors = [
      '[data-count]',
      '[data-wishlist-count]',
      '[class*="counter"]',
      '[class*="count"]',
      '[class*="badge"]'
    ].join(',');

    root.querySelectorAll(selectors).forEach(function (node) {
      var current = (node.textContent || '').trim();
      if (current === '' || /^[0-9]+$/.test(current)) {
        node.textContent = String(count);
      }
      node.setAttribute('data-ns-count', String(count));
      node.setAttribute('aria-label', 'Wishlist count ' + count);
    });
  }

  function syncFloatingWidget() {
    var count = getWishlist().length;

    document.querySelectorAll('wishlist-link-floating').forEach(function (widget) {
      widget.classList.add('ns-wishlist-floating-synced');
      widget.style.setProperty('color', '#fff', 'important');
      widget.setAttribute('data-ns-count', String(count));
      widget.setAttribute('aria-label', 'Wishlist, ' + count + (count === 1 ? ' item' : ' items'));
      patchCounterText(widget, count);
      if (widget.shadowRoot) {
        patchFloatingIcon(widget.shadowRoot);
        patchCounterText(widget.shadowRoot, count);
      }
    });

    syncStickyWishlistDock();
  }

  function isStickyAtcVisible(stickyAtc) {
    if (!stickyAtc || stickyAtc.classList.contains('sticky-atc--out')) return false;
    if (stickyAtc.classList.contains('sticky-atc--variant-unavailable')) return false;

    var rect = stickyAtc.getBoundingClientRect();
    var style = window.getComputedStyle(stickyAtc);
    return rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight && style.visibility !== 'hidden';
  }

  function syncStickyWishlistDock() {
    var stickyAtc = document.querySelector('body.template-product sticky-atc[data-sticky-atc-mobile-dock]');
    var widget = document.querySelector('wishlist-link-floating.ns-wishlist-floating-synced');
    var isMobile = window.matchMedia('(max-width: 767.98px)').matches;
    var shouldDock = isMobile && widget && isStickyAtcVisible(stickyAtc);

    if (stickyAtc) stickyAtc.classList.toggle('sticky-atc--wishlist-docked', !!shouldDock);
    if (!widget) return;

    widget.classList.toggle('ns-wishlist-floating--sticky-docked', !!shouldDock);
    if (!shouldDock) {
      widget.style.removeProperty('--ns-wishlist-dock-top');
      return;
    }

    var stickyRect = stickyAtc.getBoundingClientRect();
    var image = stickyAtc.querySelector('.sticky-atc__image');
    var imageRect = image ? image.getBoundingClientRect() : null;
    var dockTop = stickyRect.top + 12;

    if (imageRect && imageRect.height > 0) {
      dockTop = imageRect.top + Math.max(0, (imageRect.height - 44) / 2);
    }

    widget.style.setProperty('--ns-wishlist-dock-top', Math.max(8, Math.round(dockTop)) + 'px');
    observeStickyWishlistDock(stickyAtc, widget);
  }

  function scheduleStickyWishlistDock() {
    if (stickyDockFrame !== null) return;
    stickyDockFrame = window.requestAnimationFrame(function () {
      stickyDockFrame = null;
      syncStickyWishlistDock();
    });
  }

  function observeStickyWishlistDock(stickyAtc, widget) {
    if (stickyAtc !== observedStickyAtc || widget !== observedFloatingWidget) {
      if (stickyDockObserver) stickyDockObserver.disconnect();
      if (stickyDockResizeObserver) stickyDockResizeObserver.disconnect();

      observedStickyAtc = stickyAtc;
      observedFloatingWidget = widget;
      stickyDockObserver = new MutationObserver(scheduleStickyWishlistDock);
      stickyDockObserver.observe(stickyAtc, {
        attributes: true,
        attributeFilter: ['class', 'data-sticky-atc-variant-available']
      });
      stickyDockObserver.observe(widget, {
        attributes: true,
        attributeFilter: ['class', 'wk-loaded']
      });

      if ('ResizeObserver' in window) {
        stickyDockResizeObserver = new ResizeObserver(scheduleStickyWishlistDock);
        stickyDockResizeObserver.observe(stickyAtc);
      }
    }
  }

  function patchFloatingIcon(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('svg, path, [class*="icon"]').forEach(function (node) {
      node.style.setProperty('color', '#fff', 'important');
      node.style.setProperty('stroke', '#fff', 'important');
      if (node.hasAttribute('fill') && node.getAttribute('fill') !== 'none') {
        node.style.setProperty('fill', '#fff', 'important');
      }
    });
  }

  function syncProductButtons() {
    var wishlist = getWishlist();

    document.querySelectorAll('[data-ns-wishlist], .ns-wishlist-btn[data-wishlist-product]').forEach(function (button) {
      var productId = button.getAttribute('data-ns-wishlist') || button.getAttribute('data-wishlist-product');
      if (!productId) return;

      var isWished = wishlist.indexOf(String(productId)) !== -1;
      button.classList.toggle('is-wished', isWished);
      button.classList.toggle('is-active', isWished);
      button.setAttribute('aria-pressed', String(isWished));
    });
  }

  function syncAll() {
    injectStyle();
    syncProductButtons();
    syncFloatingWidget();
  }

  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncAll, 80);
  }

  function handlePrebookWishlistClick(event) {
    var button = event.target.closest('.ns-wishlist-btn[data-wishlist-product]');
    if (!button || button.hasAttribute('data-ns-wishlist')) return;

    event.preventDefault();
    event.stopPropagation();

    var productId = String(button.getAttribute('data-wishlist-product') || '').trim();
    if (!productId) return;

    var wishlist = getWishlist();
    if (wishlist.indexOf(productId) === -1) {
      wishlist.push(productId);
    } else {
      wishlist = wishlist.filter(function (id) { return id !== productId; });
    }

    setWishlist(wishlist);
    button.style.transform = 'scale(1.18)';
    window.setTimeout(function () {
      button.style.transform = '';
    }, 180);
  }

  function startObserver() {
    if (observerStarted || !document.body) return;
    observerStarted = true;
    new MutationObserver(scheduleSync).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('click', handlePrebookWishlistClick, true);
  window.addEventListener(SYNC_EVENT, scheduleSync);
  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) scheduleSync();
  });
  window.addEventListener('resize', scheduleSync);
  window.addEventListener('scroll', scheduleStickyWishlistDock, { passive: true });
  window.addEventListener('orientationchange', scheduleStickyWishlistDock);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      startObserver();
      syncAll();
    });
  } else {
    startObserver();
    syncAll();
  }

  window.addEventListener('load', function () {
    syncAll();
    window.setTimeout(syncAll, 800);
    window.setTimeout(syncAll, 2200);
  });
})();
